export const API_TIMEOUT_MS = 60_000
/** Per-request timeout for large series birth (POST /tags/birth-range). */
export const BIRTH_RANGE_TIMEOUT_MS = 15 * 60_000

